<template>
  <main class="content overview">
      <section class="heading has-padding">
        <h1>Vorgeschlagene bauliche Maßnahme</h1>
      </section>

      <section class="form has-padding">
          <h2 class="subline adj alt">{{ $store.state.check_durchlass[route_ID].action.field_name }}</h2>

            <div class="field">
                <label class="label">{{ $store.state.check_durchlass[route_ID].action.actions_title }}</label>
                <div class="select" :class="{block_Edit: !this.$store.state.is_Edit_active}">
                    <select v-model="local_selected_action">
                      <option disabled value="">Bitte auswählen</option>
                      <option 
                        v-for="(val, idx) in $store.state.check_durchlass[this.route_ID].action.actions" 
                        :key="'s' + idx"
                        :value="val"
                        >
                        {{ val }}
                      </option>
                    </select>
                    <i class="arrow down"></i>
                </div>

                <div class="field">
                    <label class="label">{{ $store.state.check_durchlass[route_ID].action.deadline_title }}</label>
                    <textarea class="textarea" :class="{block_Edit: !this.$store.state.is_Edit_active}" placeholder="Frist hinzufügen..." v-model="local_deadline"></textarea>
                </div>
            </div>
      </section>

        <div v-if="this.$store.state.is_Edit_active" class="button is-sub is-flex">
            <a @click="delete_Action()" class="link">Maßnahme entfernen</a>
        </div>

    <div v-if="this.$store.state.is_Edit_active" @click="save_Action()" class="button is-primary is-flex">
        <h3>Maßnahme speichern</h3>
    </div>
  </main>
</template>

<script>
export default {
  name: 'massnahme_durchlass',
  data () {
      return ({
        route_ID: null,
        local_actions: [],
        local_selected_action: '',
        local_deadline: ''
      })
  },
  created () {
    window.scrollTo(0, 0);
    this.update_Route()
  },
  methods: {
    goToPath () {
      this.$router.go(-1)
    },
    update_Route () {
      this.route_ID = this.$route.params.id - 1

      if (this.$store.state.check_durchlass[this.route_ID].action.selected_action.length > 0) {
        this.local_selected_action = this.$store.state.check_durchlass[this.route_ID].action.selected_action
      }

      if (this.$store.state.check_durchlass[this.route_ID].action.deadline.length > 0) {
        this.local_deadline = this.$store.state.check_durchlass[this.route_ID].action.deadline
      }
    },
    save_Action () {
      this.$store.state.check_durchlass[this.route_ID].action.selected_action = this.local_selected_action
      this.$store.state.check_durchlass[this.route_ID].action.deadline = this.local_deadline

      if (this.local_selected_action.length > 0 || this.local_deadline.length > 0) {
        this.$store.state.check_durchlass[this.route_ID].is_action_added = true
      } else {
        this.$store.state.check_durchlass[this.route_ID].is_action_added = false
      }

      this.goToPath();
    },
    delete_Action () {
      this.$store.state.check_durchlass[this.route_ID].action.selected_action = ''
      this.$store.state.check_durchlass[this.route_ID].action.deadline = ''

      this.$store.state.check_durchlass[this.route_ID].is_action_added = false

      this.goToPath();
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@media all and (min-width: 640px) and (max-width: 1100px) {

}

@media (min-width: 780px) {
  .has-padding {
    max-width: var(--maxWidth);
    margin: 0 auto;
  }
}
</style>